<template>
  <nav class="layout-footer footer" :class="getLayoutFooterBg()">
    <div class="row">
      <div class="col" style="margin-left: 0.5rem; margin-top: 0.8rem">
        <span class="footer-text font-weight-bolder">{{ $t('tracking_systems_inc') }} </span>&copy;
        <span style="text-align: center; font-family: sans-serif">{{ year }}</span>
      </div>
    </div>
  </nav>
</template>

<script>
import moment from 'moment';

export default {
  name: 'app-layout-footer',
  data() {
    return {
      year: moment().format('YYYY'),
    };
  },
  methods: {
    getLayoutFooterBg() {
      return `bg-${this.layoutFooterBg}`;
    },
  },
};
</script>
<style>
@media screen and (max-device-width: 320px) {
  .footer {
    display: none;
  }
}
</style>
